let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8f3e0")).then(() => parcelRequire('kEfpw'));